import * as cpDataList from '../services/cpData';

export default {
  namespace: 'cpDataList',
  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
    allTotal: 0,
    amountPaid: 0,
  },

  effects: {
    *getCpDataList({ payload: { values } }, { call, put }) {
      delete values.date;
      delete values.sendDate;
      delete values.refreshTime;
      const response = yield call(cpDataList.getCpDataList, values);
      yield put({
        type: 'save',
        payload: {
          cpDataList: response?.data,
        },
      });
    },
    *queryDataAmountPaid({ payload: { values } }, { call, put }) {
      delete values.date;
      delete values.sendDate;
      delete values.refreshTime;
      const response = yield call(cpDataList.queryDataAmountPaid, values);
      yield put({
        type: 'save',
        payload: {
          amountPaid: response?.data?.amountPaid || 0,
        },
      });
    },
    *getCpDataListNum({ payload: { values } }, { call, put }) {
      delete values.date;
      delete values.sendDate;
      delete values.refreshTime;
      const response = yield call(cpDataList.getCpDataList, values);
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },
    *getOrderId({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cpDataList.getOrderId, values);
      if (response.code === 0) {
        const orderData = yield call(cpDataList.getOrderDetail, {
          id: response.data,
        });
        yield put({
          type: 'save',
          payload: {
            orderData: orderData.data,
          },
        });
      }

      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *downloadDataPage({ payload: { values }, callback }, { call }) {
      const response = yield call(cpDataList.downloadDataPage, values);

      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
